import { getObject } from "../ChoiceApi"

export async function listPatientActions(): Promise<IPatientActionAndKeyModel[] | undefined>
{
    return await getObject("api/Patient/Action/List");
}

export interface IPatientActionAndKeyModel
{
    actionType: PatientActionType
    buttonText?: string
    toolTipText?: string
    newTab: boolean,
    patientActionKeyGuid: string
}

export enum PatientActionType
{
    RedoxSSO = "RedoxSSO"
}